// Constants
import TASK_STATUSES from './taskStatuses'

export const TOGGLE_AGENT_TASK = {
  id: 'TOGGLE_AGENT',
  title: 'Turn Suki badge off and on',
  status: TASK_STATUSES.PENDING
}

export const ASK_SUKI_TASK = {
  id: 'ASK_SUKI_HELP',
  title: '"Suki, What can I say ?"',
  status: TASK_STATUSES.PENDING
}

export const PATIENTS_LIST_TASK = {
  id: 'PATIENTS_ICON_CLICK',
  status: TASK_STATUSES.PENDING
}

export const NOTES_COMPLETION_TASK = {
  id: 'NOTES_COMPLETION',
  title: 'Complete 5 notes in Suki',
  status: TASK_STATUSES.PENDING,
  additional: {
    progress: {
      tasksCompleted: 0,
      totalTasks: 5
    }
  }
}

const TASKS = [
  TOGGLE_AGENT_TASK,
  ASK_SUKI_TASK,
  PATIENTS_LIST_TASK,
  NOTES_COMPLETION_TASK
]

export default TASKS
